import { IHeaderChangedState } from '../model/header-changed.model';
import { LocalStorage } from '../storage/local-storage';
import * as Actions from '../action/header-changed.action';
import * as LocalStorageConst from './../constants/header-changed.constant';

// get data from localstorage if headersLocaltate is not present returns null
const headersLocaltate = LocalStorage.getLocalObject(LocalStorageConst.HEADER_CHANGED_STATE);

// used to initialize the IHeaderChangedState with default state
const inititalState: IHeaderChangedState = headersLocaltate
  ? headersLocaltate
  : {
    isGuesthubHeaderEnabled: false
  };

export function headerChangedReducer(state: IHeaderChangedState = inititalState, action: Actions.HeaderActions): IHeaderChangedState {
  switch (action.type) {
    case Actions.APP_HEADER_STATE_CHANGED: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
}
